/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function FolderIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "folder", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M11.5 8.5H19.5V18.5H5.5V5.5H10.5L11.5 8.5ZM11.5 8.5H5.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(FolderIcon);
export default ForwardRef;
//# sourceMappingURL=folderIcon.js.map